<template>
    <b-modal id="register-input-confirm"
             :title="$t('선택 확인')"
             centered
             no-close-on-backdrop
             no-close-on-esc
             hide-footer
    >
        <b-alert variant="warning" show class="f-95 mb-4">
            {{ $t('신청 후에는 평가 대상(기업 규모)을 변경하기 어렵습니다. 선택하신 내용이 정확한지 확인해 주세요.') }}
        </b-alert>

        <div v-for="item in confirmItems" :key="`confirm-${item.id}`" class="mb-3">
            <div class="mb-2 d-flex align-items-center">
                <span class="gray-700 mr-2">{{ $t('선택한') }} {{ item.label }}</span>
                <b-badge variant="primary" pill class="f-95 px-3 py-1">{{ item.selectedLabel }}</b-badge>
            </div>
            <div v-if="item.descHtml" class="input-criteria-box" v-html="item.descHtml"/>
        </div>

        <div class="d-flex justify-content-end pt-2">
            <b-button variant="outline-secondary" class="mr-2" @click="onCancel">
                {{ $t('다시 선택') }}
            </b-button>
            <b-button variant="blue" @click="onConfirm">
                {{ $t('확인하고 계속') }}
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import {inputKeyDescriptionHtml}
from '@/components/auth/Register/_SubComponents/RegisterStep2/inputKeyDescription';

export default {
    name: 'InputConfirmModal',
    props: {
        input_keys: {
            type: Array,
            default: () => [],
        },
        form: {
            type: Object,
            required: true,
        },
    },
    computed: {
        // description(기준)이 있는 입력 = 캠페인 결정 항목(기업 규모)만 재확인 대상으로 노출
        confirmItems() {
            const locale = this.$i18n.locale;
            return (this.input_keys || [])
                .filter(item => inputKeyDescriptionHtml(item, locale))
                .map(item => ({
                    id: item.id,
                    label: item.label_texts?.[locale] || item.label_texts?.ko,
                    selectedLabel: this.selectedLabel(item, locale),
                    descHtml: inputKeyDescriptionHtml(item, locale),
                }));
        },
    },
    methods: {
        selectedLabel(item, locale) {
            const val = this.form?.[item.key_name];
            if (item.value_type === 'list') {
                const opt = (item.allowed_values || []).find(v => v.actual_value === val);
                return opt?.['label_' + locale] || opt?.label_ko || val || '-';
            }
            return (val === null || val === undefined || val === '') ? '-' : val;
        },
        onConfirm() {
            this.$emit('confirm');
        },
        onCancel() {
            this.$bvModal.hide('register-input-confirm');
            this.$emit('cancel');
        },
    },
};
</script>

<style lang="scss" scoped>
.input-criteria-box {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    padding: 10px 12px;
    font-size: 0.85rem;
    line-height: 1.6;
    color: #495057;
}
</style>
